import React, { useEffect, useState } from "react";
import { Result } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IS_MOBILE } from "@/utils/tool";
import "./index.scss";
import { clsx } from "clsx";
import Footer from "@/components/Footer";
import { useUrlSearch } from "@/hooks/useUrlSearch";
import Lottie from "lottie-react";
import loadingAnimation from "./loading.json";
import { fetchAuth } from "../../api/common";
import { setToken } from "../../api/config";

const Authorization: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const urlParamsObject = useUrlSearch();
  const [isError, setIsError] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const getAuthInfo = async () => {
      const { sign, token, data } = urlParamsObject;
      const res = await fetchAuth<{
        mobile: string;
        redirect_to: string;
        token: string;
        uid: string;
        temporary: boolean;
      }>({ data, sign, token });
      if (res.code === 0) {
        const { mobile, redirect_to, token, temporary } = res.data;
        const loginStorage = {
          phone: mobile,
          token: token,
          // 临时登录标识
          temporary,
        };
        setToken(token);
        localStorage.setItem("user", JSON.stringify({ ...loginStorage }));
        window.location.href = redirect_to;
      } else {
        setIsError(true);
        setMsg(res.msg);
      }
    };
    getAuthInfo();
  }, [location.pathname]);

  return (
    <section
      className={clsx(
        "authorization-page-wrapper",
        IS_MOBILE && "mobile-authorization-page-wrapper"
      )}
    >
      <div className="content">
        {isError ? (
          <Result status="error" title={t("授权失败")} subTitle={msg} />
        ) : (
          <Lottie animationData={loadingAnimation} loop={true} />
        )}
      </div>
      {!IS_MOBILE && <Footer />}
    </section>
  );
};

export default Authorization;
